export default __webpack_public_path__ + "source-sans-pro-v13-latin_latin-ext-600.3acdedcc1defd70c55ef.woff2";